export default "__VITE_ASSET__Dr7$UVlk__"